/** @module builtins/Window */

if (typeof window !== 'undefined') {
    // A central point for making a websocket on all platforms.
    window.MakeWebSocket = window.WebSocket || window.MozWebSocket;
}
